<template>
  <div id="user-edit-tab-info" >
    <div id="teacherFeedbackLoadingDiv" class="vs-con-loading__container" style="min-height: 300px;">
      <div class="vx-row mt-1">
        <div class="vx-col w-full mb-2">
          <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
        </div>
      </div>

      <vs-collapse type="border" accordion>
        <vs-collapse-item v-for="(feedback, feedbackIndex) in feedbacks" :key="feedbackIndex">
          <div slot="header">
            <p style="font-size: 14px">{{ feedback.module.name}} @ {{ feedback.date}}</p>
            <p style="font-size: 14px;">
              {{ feedback.student.name}} {{ feedback.student.last_name}}
              <feather-icon @click="redirectToStudent(feedback.student)" icon="ArrowRightIcon" svgClasses="w-6 h-6 "></feather-icon>
            </p>

            <div class="vx-row ml-1">
              <p style="font-size: 25px;" v-for="(singleFeedback, singleFeedbackIndex) in feedback.teacher_feedbacks" :key="singleFeedbackIndex" v-html="getEmojiWithId(singleFeedback.answer)"></p>
            </div>
          </div>
          <div class="ml-1">
            <p style="font-size: 15px;" v-for="(singleFeedback, singleFeedbackIndex) in feedback.teacher_feedbacks" :key="singleFeedbackIndex" v-html="getEmojiWithQuestion(singleFeedback)">fdfd</p>
          </div>
        </vs-collapse-item>
      </vs-collapse>

      <div class="vx-row mt-base">
        <div class="vx-col w-full mb-2">
          <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {

  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      feedbacks : [],
      totalPage: 1,
      currentPage: 1,
    }
  },
  watch: {
    currentPage(val) {
      this.getTeacherFeedbacks()
    }
  },
  computed: {

  },
  methods: {
    redirectToStudent(student) {
      this.$router.push("/students/" + student.id).catch(() => {})
    },
    getEmojiWithId(id){
      if(id == 1) return "&#128528;"
      else if(id == 2) return "&#128578;"
      else if(id == 3) return "&#128512;"
      else if(id == 4) return "&#129321;"
      else return "";
    },
    getEmojiWithQuestion(feedback){
      if(feedback.answer == 1) return "&#128528;"+" "+feedback.question
      else if(feedback.answer == 2) return "&#128578;"+" "+feedback.question
      else if(feedback.answer == 3) return "&#128512;"+" "+feedback.question
      else if(feedback.answer == 4) return "&#129321;"+" "+feedback.question
      else if(feedback.answer) return feedback.question+" : "+feedback.answer
      else return feedback.question+" : "
    },
    getTeacherFeedbacks() {
      this.$vs.loading({
        container: '#teacherFeedbackLoadingDiv',
        scale: 0.6
      })

      let data = { 
        page : this.currentPage,
        teacher_id : this.data_local.id
      };

      this.$store.dispatch("userManagement/adminViewTeacherLogbogClasses", data)
        .then(res => { 
          this.feedbacks = res.data.data
          this.totalPage = res.data.last_page
          this.$vs.loading.close('#teacherFeedbackLoadingDiv > .con-vs-loading')
        })
        .catch(err => {
          this.$vs.loading.close('#teacherFeedbackLoadingDiv > .con-vs-loading')
        })

    }
    
  },
  mounted() {
    this.getTeacherFeedbacks();

  },
  created() {
    // Register Module UserManagement Module
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
  }
}
</script>
